export default __webpack_public_path__ + "static/media/boating_vacation.7ad74338.webp";